import React from "react";
import {SensorDataListCell, StateListCell, Icon, List, StandardListCell} from "gd-react";
import './VirtualChildrenPopover.scss'
import GridDuck from "gridduck";
import InteractiveTooltip from "../InteractiveTooltip";
import history from "../../meta/history";
import EditVirtualChildrenButton from "../EditVirtualChildren/EditVirtualChildrenButton";

class VirtualChildrenPopover extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            forceClose: false
        }
        this.notificationListRef = React.createRef();
        this.getList = this.getList.bind(this)
        this.handleClose = this.handleClose.bind(this);
        // this.markNotificationsSeen = this.markNotificationsSeen.bind(this);
        this.navigateToClickedItem = this.navigateToClickedItem.bind(this);
    }

    async getList(params) {
        return await GridDuck.getAssets(params);
    }

    navigateToClickedItem(item) {
        history.push('/device/' + item.id);
    }

    handleClose() {
        if (this.props.onClose) this.props.onClose();
    }

    render() {
        return (
            <InteractiveTooltip
                key={"interactivetooltip-" + this.props.item?.id}
                tooltipClass={'virtual-children-popover'}
                popperClass={'virtual-children-popper'}
                arrowClass={'virtual-children-arrow'}
                title={
                    <div className={'issue-popover filter-menu-container'} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}>
                        {/*<div className={'row notifications-title space-between'}>*/}
                        {/*    <div>Merged Devices</div>*/}
                        {/*</div>*/}
                        <div className={'row list-container list-container-popover'}>
                            <List removeHeaders
                                  lazyload
                                  itemsPerPage={10}
                                  rowHeight={'25px'}
                                  noitemelem={<div className={'no-notifications'}>
                                      <Icon icon={'FaQuestionCircle'} size={40} color={'gd-brand'}/>
                                      <div style={{marginTop: '10px'}}>This virtual device has no children</div>
                                  </div>}
                                  columns={[
                                      {
                                          component: StandardListCell,
                                          bold: true,
                                          sortable: true,
                                          title: 'Name',
                                          field: 'name'
                                      },
                                      {
                                          component: StateListCell,
                                          sortable: false,
                                          title: 'Status',
                                          field: 'currentState',
                                          showLabel: true,
                                          permission: this.state.orgPermission
                                      },
                                      {
                                          component: SensorDataListCell,
                                          title: 'Data',
                                          field: 'temperature',
                                          maxWidth: 'none'
                                      },
                                  ]}
                                  filters={[
                                      {
                                          field: 'virtualParentAsset',
                                          value: this.props.item.id
                                      },
                                      {
                                          field: 'showVirtualMergedChildren',
                                          value: true
                                      }
                                  ]}
                                  getlist={this.getList}
                                  rowOnClick={this.navigateToClickedItem}/>
                        </div>
                        <div
                            className={'virtual-children-footer row space-between'} style={{alignItems: 'center'}}>
                            {/*<EditVirtualChildrenButton item={this.props.item}>*/}
                                <div style={{display: 'flex'}}>
                        <span className={'history-button clickable'} onClick={() => {
                            // history.push('/device/' + this.props.item.id + '/settings');
                            history.push('/device/' + this.props.item.id + '/details?editVirtualChildren=true');
                            // history.push('/device/' + this.props.item.id);
                        }}>Edit Merged Devices</span>
                                    <div className={'icon'}>
                                        <Icon size={'10'} icon={'FaChevronRight'} color={'grey'}/>
                                    </div>
                                </div>
                            {/*</EditVirtualChildrenButton>*/}
                        </div>
                    </div>}>
                <div>{this.props.children || <p>Test</p>}</div>
            </InteractiveTooltip>
        )
    }
}

export default VirtualChildrenPopover
